
import { SET_SALES_MODULE_STATUS } from '../actions/types'; 

const initialState = {
  salesModuleStatus: {},
};

const salesModuleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SALES_MODULE_STATUS: 
      console.log('[REDUCER] SET_SALES_MODULE_STATUS', action.payload);
      return {
        ...state,
        salesModuleStatus: action.payload,
      };
    default:
      return state;
  }
};

export default salesModuleReducer;